import * as React from 'react';
import { DiseaseForGridModel } from "../../models";

const diseasesList = (props) => {
	const listItems = props.diseases.map((d: DiseaseForGridModel) =>
		<li key={d.diseaseId}>
			<div className="item-info">
				<div className="item-name">
					{d.diseaseCode ? d.diseaseCode + ' ' : ''}
					{d.diseaseName ? d.diseaseName : ''}
				</div>
			</div>
		</li>
	);

	return (
		<ul className="list-items">
			{listItems}
		</ul>
	)
}

export default diseasesList;
